import { StripePaymentElementOptions } from '@stripe/stripe-js';

export const paymentElementsOptions: StripePaymentElementOptions = {
  wallets: {
    googlePay: 'never',
    applePay: 'never',
  },
};
